import {useGetCustomerGroupReport} from '../hooks/useGetCustomerGroupReport'
import {CustomerReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import {useGetCustomerTypeReport} from '../hooks/useGetCustomerTypeReport'
import CustomerTypeTable from '../sections/table/CustomerTypeTable'
import CustomerReportsHeader from '../sections/header/CustomerReportsHeader'
import CustomerGroupReportTable from '../sections/table/CustomerGroupReportTable'
import useGetCustomerGroupDropdown from '../hooks/useGetCustomerGroupDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function CustomerReport() {
  const {
    reportData: customerGroupData,
    isLoading: isCustomerGroupLoading,
    handleCustomerGroupReportDateChange,
    filters: customerGroupReportFilters,
    onSortingChange: onSortingChangeCustomerGroupReport,
    onChangeCustomerGroupFilter,
  } = useGetCustomerGroupReport()

  const {
    reportData: customerTypeData,
    isLoading: isCustomerTypeLoading,
    handleCustomerTypeReportDateChange,
    filters: customerTypeReportFilters,
    onSortingChange: onSortingChangeCustomerTypeReport,
  } = useGetCustomerTypeReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_group')

  const {
    entityPerformanceChartData: customerTypeEntityPerformanceChartData,
    isLoading: isCustomerTypeEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onCustomerTypeEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onCustomerTypeEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onCustomerTypeEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: customerTypeEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_type')

  const {customerGroups, isLoading: isCustomerGroupsLoading} = useGetCustomerGroupDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('customer_group')

  const {
    profitTrendChartData: customerTypeProfitTrendChartData,
    kpiData: customerTypeProfitTrendKpiData,
    weeklyBreakdownData: customerTypeProfitTrendWeeklyBreakdownData,
    isLoading: isCustomerTypeProfitTrendDataLoading,
    onProfitTrendIdChange: onCustomerTypeProfitTrendIdChange,
  } = useGetProfitTrend('customer_type')

  const contextValue = {
    customerGroupData,
    isCustomerGroupLoading,
    handleCustomerGroupReportDateChange,
    customerGroupReportFilters,
    onSortingChangeCustomerGroupReport,
    onChangeCustomerGroupFilter,

    customerTypeData,
    isCustomerTypeLoading,
    handleCustomerTypeReportDateChange,
    customerTypeReportFilters,
    onSortingChangeCustomerTypeReport,

    customerGroups,
    isCustomerGroupsLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    customerTypeEntityPerformanceChartData,
    isCustomerTypeEntityPerformanceChartDataLoading,
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,

    // Customer Type Profit Trend Modal Data
    customerTypeProfitTrendChartData,
    customerTypeProfitTrendKpiData,
    customerTypeProfitTrendWeeklyBreakdownData,
    isCustomerTypeProfitTrendDataLoading,
    onCustomerTypeProfitTrendIdChange,
  }

  return (
    <KTCard>
      <CustomerReportContext.Provider value={contextValue}>
        <CustomerReportsHeader />
        <CustomerGroupReportTable />
        <CustomerTypeTable />
      </CustomerReportContext.Provider>
    </KTCard>
  )
}

export default CustomerReport
